import React from "react"
import { bindActionCreators } from "redux"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import PYPInstructionContentContainer from "../PYPInstructionContentContainer/PYPInstructionContentContainer"
import { getBackgroundForTitle } from "../PYPInstructionLayout/backgroundMap"
import Actions from "../../Redux/Actions"

class LayoutMetaDataOnly extends React.Component {
  componentDidMount() {
    this.props.fetchPartData()
  }

  render() {
    const title = this.props.metadata?.title
    const description = this.props.metadata?.description
    const backgroundImage = title
      ? `url(${getBackgroundForTitle(title, this.props.partIndex)})`
      : undefined

    return (
      <div
        style={{
          ...styles.componentContainer,
          backgroundImage,
          backgroundSize: "cover",
          backgroundPosition: "center center",
          ...this.props.style
        }}
      >
        <PYPInstructionContentContainer
          title={title}
          description={description}
        />
      </div>
    )
  }
}

const styles = {
  componentContainer: {}
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch)
}

const mapStateToProps = (state, props) => {
  const currentPartId = state.pyp?.navigation?.currentPartId
  const currentPart = state.pyp?.parts?.byId?.[currentPartId]
  const partDataId = currentPart?.partData
  let metadata = { title: null, description: null }

  const partData =
    partDataId &&
    state.pyp?.partData?.byId?.[partDataId] &&
    state.pyp.partData.byId[partDataId].data

  if (partData?.title && Array.isArray(partData.title) && partData.title.length > 0) {
    metadata = partData.title[0]
  }

  const partIndex = state.pyp?.parts?.allIds?.indexOf(currentPartId) ?? 0

  return {
    ...props,
    metadata,
    partIndex
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LayoutMetaDataOnly))
